import { Snackbar } from '@flatfy/supernova';
import { initPhone } from '../../ContactsActions/ContactsPhoneButton/ContactsPhoneButton';
import { initTransitionForTabs } from '../../UiKit/Elements/Tabs/Tabs';
import { initSecondaryNavigation } from '../../SecondaryNavigation/SecondaryNavigation';

const scrollTo = () => {
  const menu = document.querySelector('#building-menu');
  if (!menu) return;
  const tabs = menu.querySelector('#building-menu-tabs');
  const active = tabs.querySelector('a.-active');
  if (tabs.offsetWidth < tabs.scrollWidth && active) {
    tabs.scrollLeft = active.offsetLeft - 36;
  }

  initTransitionForTabs(menu);
};

const initDisabledContacts = () => {
  const buttons = document.querySelectorAll('[data-disabled]');
  [].forEach.call(buttons, (button) => {
    button.addEventListener('click', () => {
      Snackbar(button.getAttribute('data-disabled'));
    });
  });
};

initPhone();
scrollTo();
initDisabledContacts();
initSecondaryNavigation({ withHistoryBack: false });
